export default class Tab {
    constructor(main) {
        this.main = main;
        this.$tabs = [...document.querySelectorAll('.js-tab')];
    }

    eventBind() {
        for (const $tab of this.$tabs) {
            const $btns = [...$tab.querySelectorAll('.js-tab_btn')];
            const $boxes = [...$tab.querySelectorAll('.js-tab_box')];
            const $bar = $tab.querySelector('.js-tab_bar');

            $btns.forEach(($btn, i) => {
                $btn.addEventListener('click', () => {
                    const $box = $boxes.find($box => $box.classList.contains('-select'));
                    const $accs = [...$boxes[i].querySelectorAll('.js-acc')];

                    $box.classList.remove('-select');
                    $boxes[i].classList.add('-select');

                    $bar.style.left = `${(100 / $btns.length) * i}%`;

                    for (const $acc of $accs) {
                        const $cont = $acc.querySelector('.js-acc_cont');
                        this.main.acc.changeHeight($acc, $cont);
                    }
                });
            });
        }
    }
}
